module.exports = __webpack_public_path__ + "static/cta-1-178e94a3fecb63df0115ca9e8075915d.jpg";